import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <img 
          src="/uploads/hero.jpg" 
          alt="Skateboarding gear and apparel marketplace" 
          className="hero-image" 
        />
        <p className="eyebrow">TheskateMarket</p>
        <h1>Your Ultimate Skateboarding Marketplace</h1>
        <p className="lede">
          Discover top-quality skateboarding gear and apparel tailored for enthusiasts like you.
        </p>
        <div className="cta-row">
          <a href="/products" className="primary">
            Browse Listings
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Explore a Wide Selection</h2>
          <p>
            From decks to shoes, we connect you with the best products to elevate your skating experience.
          </p>
        </article>
        <article>
          <h2>Stay Informed</h2>
          <p>
            Check out our tutorials, tips, and the latest in skate culture to keep your skills sharp and your style fresh.
          </p>
        </article>
        <article>
          <h2>Join the Community</h2>
          <p>
            Engage with fellow skaters and share your passion for sustainable skateboarding practices.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;